import { path } from 'ramda';

import { FEATURE_NAME as $, LIST, REQUEST_DATA } from './consts';

export const getInfoItems = path([$, LIST]);
export const getInfoItem = (id) => path([$, LIST, id]);
export const getInfoItemProp = (id) => (name) => path([$, LIST, id, name]);
export const getRequestData = path([$, REQUEST_DATA]);
